var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "search-box" }, [
    _c("div", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isSearchFocused,
          expression: "isSearchFocused"
        }
      ],
      staticClass: "od-search__backdrop",
      on: {
        click: function($event) {
          return _vm.setIsSearchFocused(false)
        }
      }
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isSearchFocused,
            expression: "isSearchFocused"
          }
        ],
        staticClass: "header-search-close__wrapper"
      },
      [
        _c(
          "div",
          {
            staticClass: "header-search-close",
            on: {
              click: function($event) {
                return _vm.setIsSearchFocused(false)
              }
            }
          },
          [
            _c("div", { staticClass: "header-search-close__inner" }, [
              _c("svg", { staticClass: "header-search-close__icon" }, [
                _c("use", {
                  attrs: {
                    "xlink:href": "#svg_close",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink"
                  }
                })
              ])
            ])
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "search-box__input-group" }, [
      _c("input", {
        staticClass: "search-box__input",
        attrs: {
          placeholder: _vm.inputPlaceholder,
          type: "text",
          autocomplete: "off"
        },
        domProps: { value: _vm.currentSearchString },
        on: {
          focus: function($event) {
            return _vm.setIsSearchFocused(true)
          },
          blur: _vm.removeFocus,
          input: function($event) {
            return _vm.setIsSearchFocused(true, $event)
          },
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.search()
          }
        }
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "search-box__button",
          attrs: { type: "submit" },
          on: {
            click: function($event) {
              return _vm.search()
            }
          }
        },
        [
          _c("svg", { staticClass: "search__icon" }, [
            _c("use", {
              attrs: {
                "xlink:href": "#svg_search",
                "xmlns:xlink": "http://www.w3.org/1999/xlink"
              }
            })
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "search-autocomplete",
        class: { "search-autocomplete--active": _vm.isSearchOpen }
      },
      [
        _c("div", { staticClass: "search-autocomplete__head" }, [
          _c("span", {
            domProps: { innerHTML: _vm._s(_vm.searchHeadlineString) }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "search-autocomplete__body-autocomplete search-autocomplete__body-autocomplete--active"
          },
          [
            _vm.articleApiLoading
              ? _c("div", { staticClass: "search-autocomplete__loading" })
              : _vm._e(),
            _vm._v(" "),
            !_vm.articleApiLoading && _vm.autocompleteResult.length > 0
              ? _c(
                  "div",
                  { staticClass: "search-autocomplete__body-categories" },
                  [
                    _vm.autocompleteResult.length > 0
                      ? [
                          _c(
                            "div",
                            {
                              staticClass:
                                "search-autocomplete__headline search-autocomplete__headline--search"
                            },
                            [_vm._v(_vm._s(_vm.searchKeywordString))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "search-autocomplete__keywords" },
                            _vm._l(_vm.autocompleteKeywords, function(keyword) {
                              return _c(
                                "div",
                                { staticClass: "search-autocomplete__keyword" },
                                [
                                  _c("span", {
                                    domProps: { innerHTML: _vm._s(keyword) }
                                  })
                                ]
                              )
                            }),
                            0
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "search-autocomplete__mdup-cats" },
                      [
                        _c(
                          "div",
                          { staticClass: "search-autocomplete__headline" },
                          [_vm._v(_vm._s(_vm.searchCategoryString))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "search-autocomplete__categories" },
                          _vm._l(_vm.autocompleteCategories, function(result) {
                            return _c(
                              "div",
                              {
                                staticClass:
                                  "search-autocomplete__item search-autocomplete__item--article-view"
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "search-autocomplete__item-inner",
                                    attrs: { href: result.url }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "search-autocomplete__img"
                                      },
                                      [
                                        _c("img", {
                                          attrs: { src: result.image }
                                        })
                                      ]
                                    ),
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(result.name)
                                    ),
                                    _c("i", {
                                      staticClass: "fa fa-chevron-right"
                                    })
                                  ]
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    )
                  ],
                  2
                )
              : !_vm.articleApiLoading && _vm.autocompleteResult.length == 0
              ? _c(
                  "div",
                  { staticClass: "search-autocomplete__body-categories" },
                  [
                    _vm.autocompleteResult.length == 0
                      ? [
                          _c(
                            "div",
                            {
                              staticClass:
                                "search-autocomplete__headline search-autocomplete__headline--search"
                            },
                            [_vm._v(_vm._s(_vm.searchKeywordString))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "search-autocomplete__keywords" },
                            _vm._l(_vm.autocompleteKeywords, function(keyword) {
                              return _c(
                                "div",
                                { staticClass: "search-autocomplete__keyword" },
                                [
                                  _c("span", {
                                    domProps: { innerHTML: _vm._s(keyword) }
                                  })
                                ]
                              )
                            }),
                            0
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.articleApiLoading && _vm.autocompleteResult.length > 0
              ? _c(
                  "div",
                  { staticClass: "search-autocomplete__body-article" },
                  [
                    _c(
                      "div",
                      { staticClass: "search-autocomplete__headline" },
                      [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "/search?query=" + _vm.currentSearchString
                            }
                          },
                          [
                            _c("u", {
                              domProps: { innerHTML: _vm._s(_vm.searchShowAll) }
                            })
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.autocompleteResult, function(result) {
                      return _c(
                        "div",
                        { staticClass: "search-autocomplete__article" },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "search-autocomplete__article-inner",
                              attrs: { href: result.url }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "search-autocomplete__article-image"
                                },
                                [
                                  _c("img", {
                                    attrs: { src: result.mainImage }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "search-autocomplete__article-name"
                                },
                                [
                                  _c("span", [_vm._v(_vm._s(result.name))]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "search-autocomplete__article-price-wrapper d-flex"
                                    },
                                    [
                                      result.rrp
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "search-autocomplete__article-cross-price w-auto"
                                            },
                                            [_vm._v(_vm._s(result.rrp))]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "search-autocomplete__article-price"
                                        },
                                        [_vm._v(_vm._s(result.price))]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.articleApiLoading && _vm.autocompleteResult.length == 0
              ? _c(
                  "div",
                  { staticClass: "search-autocomplete__body-article" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$translate(
                            "Weberbuero::Template.searchNothingFound"
                          )
                        ) +
                        "\n            "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.articleApiLoading && _vm.autocompleteResult.length > 0
              ? _c("div", { staticClass: "search-autocomplete__mobile-cats" }, [
                  _c("div", { staticClass: "search-autocomplete__headline" }, [
                    _vm._v(_vm._s(_vm.searchCategoryString))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "search-autocomplete__categories" },
                    _vm._l(_vm.autocompleteCategories, function(result) {
                      return _c(
                        "div",
                        {
                          staticClass:
                            "search-autocomplete__item search-autocomplete__item--article-view"
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "search-autocomplete__item-inner",
                              attrs: { href: result.url }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "search-autocomplete__img" },
                                [_c("img", { attrs: { src: result.image } })]
                              ),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(result.name)
                              ),
                              _c("i", { staticClass: "fa fa-chevron-right" })
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  )
                ])
              : _vm._e()
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }